import { createFileRoute, useParams } from "@tanstack/react-router";
import { AppsPage } from "~/pages/AppsPage";
import { queryClient, trpc } from "~/utils/trpc";
import { useBreadCrumbs } from "~/contexts/useBreadCrumbs";

export const Route = createFileRoute("/_dashboard/$datasetSlug/apps/")({
  component: RouteComponent,
  loader: async () => {
    const apps = await queryClient.fetchQuery(trpc.apps.getAllPublished.queryOptions());
    return { apps };
  },
});

function RouteComponent() {
  const { datasetSlug } = useParams({ from: "/_dashboard/$datasetSlug" });
  useBreadCrumbs([{ title: "Apps", link: `/${datasetSlug}/apps` }]);
  const { apps } = Route.useLoaderData();
  return <AppsPage apps={apps} />;
}
